@if (mainImage$ | async; as main) {
  @if (thumbnails$ | async; as thumbs) {
    <div class="cx-main-image-group">
      <div class="cx-navigate-image">
        @if (getPreviousProduct($any(thumbs)) | async; as previousProduct) {
          <button
            class="btn btn-link"
            [attr.aria-label]="'productImageZoomDialog.previousSlide' | cxTranslate"
            [attr.title]="'productImageZoomDialog.previousSlide' | cxTranslate"
            (click)="openImage($any(previousProduct['container']))"
            >
            <cx-icon [type]="iconType.CARET_LEFT"></cx-icon>
          </button>
        }
      </div>
      <!-- TODO: (CXSPA-7492) - Remove feature flag next major release. -->
      <div *cxFeature="'a11yKeyboardAccessibleZoom'" class="cx-image-container">
        @if (isVideo(main)) {
          <custom-video
            class="cx-default-image-zoom"
            [data]="convertToVideoSource(main)"
          ></custom-video>
        } @else {
          @if (!isZoomed) {
            <cx-media
              #defaultImage
              class="cx-default-image-zoom"
              (loaded)="onImageLoad()"
              [container]="main"
              >
            </cx-media>
          }
        }
        @if (isZoomed) {
          <div #zoomContainer class="cx-zoom-container">
            @if (isVideo(main)) {
              <custom-video [data]="convertToVideoSource(main)"></custom-video>
            } @else {
              <cx-media
                #zoomedImage
                class="cx-image-zoomed"
                [container]="main"
                (mousemove)="pointerMove($event)"
                (touchmove)="touchMove($event)"
                (touchend)="clearTouch()"
                (loaded)="onImageLoad()"
                >
              </cx-media>
            }
          </div>
        }
        @if ((imageLoaded | async) && !isVideo(main)) {
          <button
            #zoomButton
        [attr.aria-label]="
          isZoomed ? ('common.zoomOut' | cxTranslate) : ('common.zoomIn' | cxTranslate)
        "
            title="{{ isZoomed ? ('common.zoomOut' | cxTranslate) : ('common.zoomIn' | cxTranslate) }}"
            class="btn btn-link cx-zoom-btn"
            (click)="zoom()"
            >
            @if (!isZoomed) {
              <cx-icon
                [type]="iconType.SEARCH_PLUS"
                class="cx-zoom-indicator"
              ></cx-icon>
            }
            @if (isZoomed) {
              <cx-icon
                [type]="iconType.SEARCH_MINUS"
                class="cx-zoom-indicator"
              ></cx-icon>
            }
          </button>
        }
      </div>
      <ng-container *cxFeature="'!a11yKeyboardAccessibleZoom'">
        @if (!isZoomed) {
          <cx-media #defaultImage class="cx-default-image-zoom" [container]="main">
          </cx-media>
        }
        @if (isZoomed) {
          <div #zoomContainer class="cx-zoom-container">
            @if (isVideo(main)) {
              <custom-video [data]="convertToVideoSource(main)"></custom-video>
            } @else {
              <cx-media
                #zoomedImage
                class="cx-image-zoomed"
                [container]="main"
                (mousemove)="pointerMove($event)"
                (touchmove)="touchMove($event)"
                (touchend)="clearTouch()"
                >
              </cx-media>
              }</div
              >
            }</ng-container>
            <div class="cx-navigate-image">
              @if (getNextProduct($any(thumbs)) | async; as nextProduct) {
                <button
                  class="btn btn-link"
                  [attr.aria-label]="'productImageZoomDialog.nextSlide' | cxTranslate"
                  [attr.title]="'productImageZoomDialog.nextSlide' | cxTranslate"
                  (click)="openImage($any(nextProduct['container']))"
                  >
                  <cx-icon [type]="iconType.CARET_RIGHT"></cx-icon>
                </button>
              }
            </div>
          </div>
        }
      }
      <cx-product-image-zoom-thumbnails
        [thumbs$]="$any(thumbnails$)"
        [activeThumb]="activeThumb"
        (productImage)="changeImage($event)"
      ></cx-product-image-zoom-thumbnails>
